import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router';

export const AutoSignin = ({ disabled = false }: { disabled?: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const user = localStorage.getItem('user');

    if (!user) return setIsLoading(false);

    if (!location.pathname.includes('/dashboard')) navigate('/dashboard');
    setIsLoading(false);
  }, []);

  if (!isLoading || disabled)
    return (
      <>
        <Outlet />
      </>
    );

  return <></>;
};
